// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardVoidStatusCard_root__wCqC+","text":"PlasmicDashboardVoidStatusCard_text__Uito9"};